import { useMemo } from "react"
import { deriveMeetingSpeakers, type IDeriveMeetingInput, type ISpeakerVMResult } from "../lib/speaker-vm"

/**
 * Memoised speaker view-model for a meeting. The single entry point every
 * speaker surface reads — legend, panel, transcript page, summary cards — so
 * they share one colour / initials / status / dedupe derivation.
 *
 * Recomputes only when `meeting` changes identity; callers should pass the
 * query's `data` object directly (it's stable between renders).
 */
export function useMeetingSpeakers(meeting: IDeriveMeetingInput | null | undefined): ISpeakerVMResult {
  return useMemo(() => deriveMeetingSpeakers(meeting ?? {}), [meeting])
}
